import { Options } from '@contentful/rich-text-react-renderer';
import { BLOCKS, INLINES, Node } from '@contentful/rich-text-types';
import { ReactNode } from 'react';

import { ExternalLink } from '../Clickables/ExternalLink/ExternalLink';
import { Divider } from '../Divider/Divider';
import { Heading } from '../Heading/Heading';
import { Text } from '../Text/Text';

// Common Contentful rich-text renderers shared across the app (paragraphs,
// lists, headings, links, etc.). Surfaces consistent typography via the
// Fishbrain UI primitives. Blog content extends this with embedded entries,
// assets, and the iframe code mark — see BlogPostContent/helpers/getRichTextOptions.tsx.
export const getBaseRichTextOptions = (): Options => ({
  renderNode: {
    [BLOCKS.HR]: (_: Node) => <Divider variant="md" />,
    [BLOCKS.LIST_ITEM]: (_: Node, children: ReactNode) => <li className="-mt-2">{children}</li>,
    [BLOCKS.OL_LIST]: (_: Node, children: ReactNode) => (
      <ol className="list-decimal">{children}</ol>
    ),
    [BLOCKS.UL_LIST]: (_: Node, children: ReactNode) => <ul className="list-disc">{children}</ul>,
    [BLOCKS.PARAGRAPH]: (_: Node, children: ReactNode) => <Text className="mb-0">{children}</Text>,
    [BLOCKS.QUOTE]: (_: Node, children: ReactNode) => (
      <blockquote className="italic">{children}</blockquote>
    ),
    [BLOCKS.HEADING_1]: (_: Node, children: ReactNode) => (
      <Heading as="h1" variant="2xl">
        {children}
      </Heading>
    ),
    [BLOCKS.HEADING_2]: (_: Node, children: ReactNode) => (
      <Heading as="h2" variant="sm" className="mb-4">
        {children}
      </Heading>
    ),
    [BLOCKS.HEADING_3]: (_: Node, children: ReactNode) => (
      <Heading as="h3" variant="xs" className="mb-4">
        {children}
      </Heading>
    ),
    [BLOCKS.HEADING_4]: (_: Node, children: ReactNode) => (
      <Heading as="h4" variant="xs" className="mb-4">
        {children}
      </Heading>
    ),
    [INLINES.HYPERLINK]: (node: Node, children: ReactNode) => (
      <ExternalLink target="_blank" href={`${node.data.uri}`}>
        {children}
      </ExternalLink>
    ),
  },
});
